export const messages = {
  en: {
    roomCreateFee: {
      customTemplate: 'Custom Template',
      customImport: 'Custom Import',
      batchCreate: 'Batch Create',
      batchCollectionLetter: 'Batch Collection Letter',
      roomNumPlaceholder: 'Room number, e.g. 1-1-1123',
      ownerNamePlaceholder: 'Please enter owner name',
      roomFee: 'Room Fee',
      paymentHistory: 'Payment History',
      rooms: 'Rooms',
      owner: 'Owner',
      callable: 'Callable',
      receiptReprint: 'Receipt Reprint',
      meterReadingRecords: 'Meter Reading Records',
      prepaidAccount: 'Prepaid Account',
      prepaidReprint: 'Prepaid Reprint',
      deposit: 'Deposit',
      billingRules: 'Billing Rules',
      feeBills: 'Fee Bills',
      prePayFee: 'Pre Pay Fee',
      onlyHasOwnerTip: 'Only rooms with owners are displayed'
    },
    inputSearchRoom: {
      noRoomFound: 'No room found'
    },
    inputSearchRoomDemo: {
      searchPlaceholder: 'Search by room number'
    },
    inputSearchRoomByOwnerDemo: {
      searchPlaceholder: 'Search by owner name'
    },
    tempImportRoomFee: {
      title: 'Temporary Fee',
      feeType: 'Fee Type',
      selectFeeType: 'Required, please select fee type',
      feeObj: 'Fee Object',
      inputFeeObj: 'Required, please fill in fee object',
      feeName: 'Fee Name',
      selectFeeItem: 'Required, please select fee item',
      feeItemDesc: 'Description: Items with formulas are dynamic fee items',
      inputFeeName: 'Required, please fill in fee name',
      select: 'Select',
      amount: 'Amount',
      inputAmount: 'Required, please fill in amount',
      startTime: 'Start Time',
      selectStartTime: 'Required, please select start time',
      endTime: 'End Time',
      selectEndTime: 'Required, please select end time',
      cancel: 'Cancel',
      submit: 'Submit',
      feeTypeRequired: 'Fee type cannot be empty',
      feeNameRequired: 'Fee name cannot be empty',
      feeObjRequired: 'Fee object cannot be empty',
      startTimeRequired: 'Start time cannot be empty',
      endTimeRequired: 'End time cannot be empty',
      endTimeMustAfterStart: 'End time must be after start time',
      amountRequired: 'Amount cannot be empty',
      createSuccess: 'Created successfully',
      createFailed: 'Creation failed'
    },
    tempImportRoomFeeDemo: {
      openModal: 'Open Temporary Fee Modal'
    },
    simplifyRoomFee: {
      selectFeeType: 'Select Fee Type',
      selectFeeItem: 'Select Fee Item',
      selectStatus: 'Select Status',
      currentRoom: 'Current Room',
      currentOwner: 'Current Owner',
      default: 'Default',
      monthly: 'Monthly',
      batchPayment: 'Batch Payment',
      tempFee: 'Temporary Fee',
      quantityPayment: 'Quantity Payment',
      waterElectricity: 'Water & Electricity',
      feePackage: 'Fee Package',
      createFee: 'Create Fee',
      arrearsPayment: 'Arrears Payment',
      feeItem: 'Fee Item',
      feeFlag: 'Fee Flag',
      feeType: 'Fee Type',
      receivableAmount: 'Receivable Amount',
      accountTime: 'Account Time',
      receivablePeriod: 'Receivable Period',
      description: 'Description',
      remark: 'Remark',
      status: 'Status',
      operation: 'Operation',
      preDegrees: 'Previous Degrees:',
      curDegrees: 'Current Degrees:',
      unitPrice: 'Unit Price:',
      additionalFee: 'Additional Fee:',
      usage: 'Usage:',
      algorithm: 'Algorithm:',
      fixedFee: 'Fixed Fee:',
      moreOperations: 'More Operations',
      cancelFee: 'Cancel Fee',
      manualEnd: 'Manual End',
      feeChange: 'Fee Change',
      details: 'Details',
      chargeYearMonth: 'Charge Year-Month',
      note1: 'Note: The receivable end time "-" means not yet receivable or fee collection has ended',
      note2: 'Receivable amount -1 generally indicates an error in the fee item formula setting, please check',
      arrearsSubtotal: 'Arrears Subtotal:',
      valid: 'Valid',
      feeEnd: 'Fee End',
      payment: 'Payment',
      prePayFee: 'Pre Pay Fee',
      paymentHistory: 'Payment History',
      splitFee: 'Split Fee'
    },
simplifyHisFee: {
      feeItem: 'Fee Item',
      payerObject: 'Payer Object',
      receiptNumber: 'Receipt Number',
      manualGenerate: 'Manual Generate',
      cycle: 'Cycle(Month)',
      receivableReceived: 'Receivable/Received(Yuan)',
      accountDeduction: 'Account Deduction',
      acctAmount: 'Account Deduction',
      discountAmount: 'Discount Amount',
      deductionAmount: 'Deduction Amount',
      lateAmount: 'Late Fee',
      giftAmount: 'Gift Amount',
      discountDetail: 'Discount Detail',
      paymentMethod: 'Payment Method',
      paymentPeriod: 'Payment Period',
      paymentTime: 'Payment Time',
      cashier: 'Cashier',
      status: 'Status',
      remark: 'Remark',
      operation: 'Operation',
      detail: 'Detail',
      generateReceipt: 'Generate Receipt',
      systemGenerate: 'System Generate',
      custom: 'Custom',
      receiptNumberRequired: 'Required, please select receipt number generation method',
      cancel: 'Cancel',
      generate: 'Generate',
      viewInFee: 'view in fee'
    },
    simplifyOwnerRooms: {
      batchPay: 'Batch Payment',
      roomCode: 'Room Code',
      floor: 'Floor',
      type: 'Type',
      area: 'Built/Indoor Area',
      rent: 'Rent',
      validity: 'Validity',
      roomStatus: 'Room Status',
      roomOweFee: 'Room Owe Fee',
      updateDaily: 'Update Daily',
      actions: 'Actions',
      choose: 'Choose',
      currentRoom: 'Current Room',
      subtotalOweFee: 'Subtotal Owe Fee',
      note1: 'Note: End time "-" means not yet due or fee collection has ended',
      note2: 'Note: Receivable amount -1 generally indicates formula error, please check'
    },
    carDetailOwner: {
      ownerFace: 'Owner Face',
      name: 'Name',
      gender: 'Gender',
      male: 'Male',
      female: 'Female',
      idCard: 'ID Card',
      address: 'Address',
      roomCount: 'Room Count',
      memberCount: 'Member Count',
      carCount: 'Car Count',
      complaintCount: 'Complaint',
      repairCount: 'Repair',
      oweFee: 'Owe Fee',
      contractCount: 'Contract',
      actions: 'Actions',
      detail: 'Detail'
    },
    writeOweFeeCallable: {
      title: 'Callable Registration',
      room: 'Registration Room',
      roomPlaceholder: 'Required, please fill in the room',
      fees: 'Callable Fees',
      remark: 'Callable Remark',
      remarkPlaceholder: 'Please enter remark',
      cancel: 'Cancel',
      submit: 'Submit',
      success: 'Registration successful'
    },
    deleteOweFeeCallable: {
      title: 'Please confirm your operation!',
      confirmDelete: 'Confirm to delete owe fee callable',
      cancel: 'Cancel',
      confirm: 'Confirm Delete!',
      success: 'Delete successful'
    },
    simplifyCallable: {
      register: 'Register',
      callable: 'Callable',
      callableOrder: 'Callable Order',
      noRoomSelected: 'No room selected',
      id: 'ID',
      ownerName: 'Owner Name',
      payerObjName: 'Payer Object Name',
      feeName: 'Fee Name',
      amount: 'Amount',
      timePeriod: 'Time Period',
      callableWay: 'Callable Way',
      staffName: 'Staff Name',
      status: 'Status',
      remark: 'Remark',
      createTime: 'Create Time',
      actions: 'Operations',
      delete: 'Delete'
    },
    simplifyFeeReceipt: {
      selectFeeType: 'Please select fee type',
      selectCar: 'Please select car',
      selectContract: 'Please select contract',
      current: 'Current ',
      car: 'Car',
      room: 'Room',
      all: 'All ',
      receiptCode: 'Receipt Code',
      query: 'Query',
      print: 'Print',
      mergePrint: 'Merge Print',
      printSmall: 'Print Small',
      apply: 'Apply',
      feeType: 'Fee Type',
      owner: 'Owner',
      feeItem: 'Fee Item',
      timePeriod: 'Time Period',
      totalAmount: 'Total Amount',
      payTime: 'Pay Time',
      receiptId: 'Receipt ID',
      yuan: 'Yuan',
      fee: 'Fee',
      noCar: 'No car',
      noContract: 'No contract',
      selectReceipt: 'Please select receipt',
      contract: 'Contract',
      feeMonth: 'Billing Month',
      payWay: 'Payment Method',
      deductionAmount: 'Discount Amount',
      lateAmount: 'Late Fee',
      acctAmount: 'Account Deduction',
      degree: 'Meter Reading (Start ~ End)'
    },
    simplifyMeterWaterLog: {
      selectMeterType: 'Select meter type',
      addMeterReading: 'Add meter reading',
      meterType: 'Meter Type',
      objectName: 'Object Name',
      previousReading: 'Previous Reading',
      currentReading: 'Current Reading',
      previousReadingTime: 'Previous Reading Time',
      currentReadingTime: 'Current Reading Time',
      createTime: 'Create Time'
    },
    prestoreAccount: {
      title: 'Prestore',
      accountType: 'Account Type',
      selectAccountType: 'Please select account type',
      ownerPhone: 'Owner Phone',
      ownerPhonePlaceholder: 'Required, please enter owner phone',
      ownerName: 'Owner Name',
      selectOwner: 'Required, please select owner',
      deductionRoom: 'Deduction Room',
      selectRoom: 'Required, please select room',
      prestoreAmount: 'Prestore Amount',
      prestoreAmountPlaceholder: 'Required, please enter prestore amount',
      paymentMethod: 'Payment Method',
      selectPaymentMethod: 'Required, please select payment method',
      remark: 'Remark',
      remarkPlaceholder: 'Optional, please enter remark',
      cancel: 'Cancel',
      save: 'Save',
      validateOwner: 'Owner cannot be empty',
      validateAmount: 'Amount cannot be empty',
      validateAccountType: 'Please select account type',
      validateRemark: 'Remark cannot exceed 200 characters',
      saveSuccess: 'Prestore success',
      saveFailed: 'Prestore failed'
    },

    simplifyRefundDeposit: {
      chargeObject: 'Charge Object',
      feeItem: 'Fee Item',
      timePeriod: 'Time Period',
      amount: 'Amount',
      paymentTime: 'Payment Time',
      status: 'Status',
      operation: 'Operation',
      refundDeposit: 'Refund Deposit',
      detail: 'Detail'
    },
    deleteFeeRule: {
      confirmTitle: 'Please confirm your operation',
      confirmMessage: 'Confirm to delete the fee rule? When deleting the fee rule, related fees and payment records will also be deleted!',
      cancel: 'Cancel',
      confirmDelete: 'Confirm Delete',
      deleteSuccess: 'Delete success',
      deleteFailed: 'Delete failed'
    },
    editFeeRule: {
      title: 'Bill Change',
      maxTime: 'Bill End Time',
      maxTimePlaceholder: 'Required, please fill in the bill end time',
      curYearMonth: 'Bill Day',
      curYearMonthPlaceholder: 'Required, please fill in the bill day',
      dateError: 'Bill day should be greater than {date}',
      maxTimeRequired: 'Bill end time is required',
      curYearMonthRequired: 'Bill day is required'
    },
    finishFeeRule: {
      title: 'Please confirm your operation',
      confirmMessage: 'End the fee bill, no new bill fees will be generated on the bill day!'
    },
    feeDetailFeeRule: {
      ruleId: 'Rule ID',
      feeItem: 'Fee Item',
      feeFlag: 'Fee Flag',
      createTime: 'Create Time',
      validPeriod: 'Valid Period',
      formula: 'Bill Formula',
      price: 'Price',
      additionalFee: 'Additional/Fixed Fee',
      status: 'Status',
      billDay: 'Bill Day',
      billCycle: 'Bill Cycle'
    },
    feeDetailRuleBill: {
      billName: 'Bill Name',
      feeItem: 'Fee Item',
      receivablePeriod: 'Receivable Period',
      receivableAmount: 'Receivable Amount',
      ruleId: 'Rule ID',
      feeId: 'Fee ID',
      status: 'Status',
      description: 'Description',
      price: 'Price',
      fixedFee: 'Fixed Fee'
    },
    deleteFee: {
      title: 'Please confirm your operation',
      confirmMessage: 'Confirm to delete the fee'
    },
    editFee: {
      title: 'Fee Change',
      startTime: 'Start Time',
      startTimePlaceholder: 'Required, please fill in the create time',
      endTime: 'End Time',
      endTimePlaceholder: 'Required, please fill in the end time',
      maxEndTime: 'Receivable End Time',
      maxEndTimePlaceholder: 'Required, please fill in the receivable end time',
      rateCycle: 'Rate Cycle',
      rateCyclePlaceholder: 'Required, please fill in the rate cycle (months)',
      rate: 'Rate',
      ratePlaceholder: 'Required, please fill in the rate',
      rateStartTime: 'Rate Start Time',
      rateStartTimePlaceholder: 'Required, please fill in the rate start time',
      startTimeError: 'Create time must be less than receivable start time',
      endTimeError: 'Receivable start time must be greater than create time',
      maxEndTimeError: 'Receivable end time must be greater than create time',
      rateStartTimeError: 'Rate start time must be greater than create time',
      startTimeRequired: 'Create time is required',
      endTimeRequired: 'Receivable start time is required',
      oweAmount: 'Owe Amount',
      oweAmountPlaceholder: 'Required, please fill in the owe amount'
    },
    roomCreateFeeAdd: {
      title: 'Create Fee',
      location: 'Room',
      locationPlaceholder: 'Required, please fill in the charge scope',
      feeType: 'Fee Type',
      feeTypePlaceholder: 'Required, please select fee type',
      feeItem: 'Fee Item',
      feeItemPlaceholder: 'Required, please select fee item',
      amount: 'Amount',
      amountPlaceholder: 'Required, please fill in the amount',
      startTime: 'Start Time',
      startTimePlaceholder: 'Required, please fill in start time',
      endTime: 'End Time',
      endTimePlaceholder: 'Required, please fill in end time',
      rateCycle: 'Rate Cycle',
      rateCyclePlaceholder: 'Required, please fill in rate cycle (months)',
      rate: 'Rate',
      ratePlaceholder: 'Required, please fill in rate',
      rateStartTime: 'Rate Start Time',
      rateStartTimePlaceholder: 'Required, please fill in rate start time',
      validate: {
        locationRequired: 'Room is required',
        feeTypeRequired: 'Fee type is required',
        feeItemRequired: 'Fee item is required',
        startTimeRequired: 'Start time is required',
        endTimeRequired: 'End time is required',
        startBeforeEnd: 'Start time must be before end time',
        endAfterStart: 'End time must be after start time'
      },
      successMessage: 'Fee created successfully'
    },
    roomCreateFeeAddDemo: {
      openModal: 'Open Create Fee Modal',
      successMessage: 'Fee created successfully'
    },
    addProxyFee: {
      title: 'Pay by Quantity',
      feeType: 'Fee Type',
      feeTypePlaceholder: 'Required, please select fee type',
      feeItem: 'Fee Item',
      feeItemPlaceholder: 'Required, please select fee item',
      feeItemTip: 'Note: Display items with formula (usage * unit price + additional fee)',
      chargeObject: 'Charge Object',
      chargeObjectPlaceholder: 'Required, please fill in room',
      consumption: 'Consumption',
      consumptionPlaceholder: 'Required, please fill in consumption',
      quantity: 'Quantity',
      amount: 'Amount',
      amountPlaceholder: 'Required, please fill in amount',
      startTime: 'Start Time',
      startTimePlaceholder: 'Required, please fill in start time',
      endTime: 'End Time',
      endTimePlaceholder: 'Required, please fill in end time',
      waterFee: 'Water Fee',
      electricityFee: 'Electricity Fee',
      otherFee: 'Other',
      validate: {
        amountRequired: 'Amount is required',
        amountFormat: 'Invalid amount format, e.g. 3.00',
        consumptionRequired: 'Consumption is required',
        consumptionFormat: 'Invalid consumption format, e.g. 3.00',
        roomRequired: 'Room is required',
        feeRequired: 'Fee is required',
        startTimeRequired: 'Start time is required',
        endTimeRequired: 'End time is required',
        startBeforeEnd: 'Start time must be before end time',
        endAfterStart: 'End time must be after start time',
        invalidConfig: 'Invalid fee item or formula error',
        amountTooSmall: 'Amount is too small'
      },
      successMessage: 'Saved successfully'
    },
    addProxyFeeDemo: {
      openModal: 'Open Pay by Quantity Modal',
      successMessage: 'Saved successfully'
    },
    exportFeeImportExcel: {
      title: 'Template Export',
      floor: 'Floor',
      feeItem: 'Fee Item',
      all: 'All',
      successMessage: 'Export successful'
    },
    exportFeeImportExcelDemo: {
      openModal: 'Open Template Export Modal'
    },
    doImportCreateFee: {
      title: 'Custom Create Fee',
      selectFile: 'Select File',
      clickUpload: 'Click to upload',
      fileTip: 'Required, please select data file',
      validate: {
        invalidFileType: 'Invalid Excel format',
        fileTooLarge: 'Excel file size cannot exceed 2MB'
      },
      successMessage: 'Import successful'
    },
    doImportCreateFeeDemo: {
      openModal: 'Open Custom Create Fee Modal'
    },
    downloadCollectionLetterOrder: {
      title: 'Batch Collection Letter',
      confirmExport: 'Confirm to export collection letter',
      selectFloor: 'Select Floor',
      floorPlaceholder: 'Required, please select floor'
    },
    downloadCollectionLetterOrderDemo: {
      openModal: 'Open Collection Letter Modal'
    },
    prePayFeeDetail: {
      feeName: 'Fee Name',
      payerObjName: 'Payer Object',
      ownerName: 'Owner Name',
      cycles: 'Cycle',
      receivableReceivedAmount: 'Receivable/Received Amount',
      remainAmount: 'Remaining Amount',
      primeRateName: 'Payment Method',
      prePayPeriod: 'Prepay Period',
      stateName: 'Status',
      cashierName: 'Cashier',
      discountAmount: 'Discount Amount',
      createTime: 'Prepay Time',
      deductionWay: 'Deduction',
      remark: 'Remark',
      operation: 'Operation',
      refund: 'Refund',
      manualDeduction: 'Manual Deduction',
      autoDeduction: 'Auto Deduction',
      deductionDetail: 'Deduction Detail',
      totalRemainAmount: 'Total Remaining Amount',
      auto: 'Auto',
      manual: 'Manual',
      fetchError: 'Failed to get prepay fee details',
      operationSuccess: 'Operation successful',
      operationError: 'Operation failed'
    },
    splitFee: {
      title: 'Split Fee',
      feeName: 'Fee Item:',
      timePeriod: 'Time Period:',
      oweAmount: 'Receivable Amount:',
      remark: 'Description',
      operation: 'Operation',
      oweAmountPlaceholder: 'Required, please fill in receivable amount',
      remarkPlaceholder: 'Optional, please fill in description',
      add: 'Add',
      delete: 'Delete',
      amountSumError: 'Sum of split amounts does not equal receivable amount!',
      operationSuccess: 'Operation successful'
    }
  },
  zh: {
    roomCreateFee: {
      customTemplate: '自定义模板',
      customImport: '自定义导入',
      batchCreate: '批量创建',
      batchCollectionLetter: '批量催缴单',
      roomNumPlaceholder: '房屋编号,如1-1-1123',
      ownerNamePlaceholder: '请填写业主名称',
      roomFee: '房屋费用',
      paymentHistory: '缴费历史',
      rooms: '房屋',
      owner: '业主',
      callable: '催缴',
      receiptReprint: '补打收据',
      meterReadingRecords: '抄表记录',
      prepaidAccount: '预存账户',
      prepaidReprint: '预存补打',
      deposit: '押金',
      billingRules: '设置费用',
      feeBills: '费用账单',
      prePayFee: '预付收款',
      onlyHasOwnerTip: '仅显示有业主的房屋'
    },
    inputSearchRoom: {
      noRoomFound: '未查询到房屋'
    },
    inputSearchRoomDemo: {
      searchPlaceholder: '按房号搜索'
    },
    inputSearchRoomByOwnerDemo: {
      searchPlaceholder: '按业主姓名搜索'
    },
    tempImportRoomFee: {
      title: '临时收费',
      feeType: '费用类型',
      selectFeeType: '必填，请选择费用类型',
      feeObj: '费用对象',
      inputFeeObj: '必填，请填写费用对象',
      feeName: '费用名称',
      selectFeeItem: '必填，请选择收费项目',
      feeItemDesc: '说明：显示公式为动态费用的费用项',
      inputFeeName: '必填，请填写费用名称',
      select: '选择',
      amount: '收费金额',
      inputAmount: '必填，请填写收费金额',
      startTime: '开始时间',
      selectStartTime: '必填，请填写开始时间',
      endTime: '结束时间',
      selectEndTime: '必填，请填写结束时间',
      cancel: '取消',
      submit: '提交',
      feeTypeRequired: '费用类型不能为空',
      feeNameRequired: '费用名称不能为空',
      feeObjRequired: '费用对象不能为空',
      startTimeRequired: '开始时间不能为空',
      endTimeRequired: '结束时间不能为空',
      endTimeMustAfterStart: '结束时间必须大于开始时间',
      amountRequired: '金额不能为空',
      createSuccess: '创建成功',
      createFailed: '创建失败'
    },
    tempImportRoomFeeDemo: {
      openModal: '打开临时收费模态框'
    },
    simplifyRoomFee: {
      selectFeeType: '请选择费用类型',
      selectFeeItem: '请选择收费项目',
      selectStatus: '请选择状态',
      currentRoom: '当前房屋',
      currentOwner: '当前业主',
      default: '默认',
      monthly: '按月',
      batchPayment: '批量缴费',
      tempFee: '临时收费',
      quantityPayment: '按量缴费',
      waterElectricity: '水电抄表',
      feePackage: '费用套餐',
      createFee: '创建费用',
      arrearsPayment: '欠费缴费',
      feeItem: '费用项目',
      feeFlag: '费用标识',
      feeType: '费用类型',
      receivableAmount: '应收金额',
      accountTime: '建账时间',
      receivablePeriod: '应收时间段',
      description: '说明',
      remark: '备注',
      status: '状态',
      operation: '操作',
      preDegrees: '上期度数：',
      curDegrees: '本期度数：',
      unitPrice: '单价：',
      additionalFee: '附加费：',
      usage: '用量：',
      algorithm: '算法：',
      fixedFee: '固定费：',
      moreOperations: '更多操作',
      cancelFee: '取消费用',
      manualEnd: '手工结束',
      feeChange: '费用变更',
      details: '详情',
      chargeYearMonth: '收费年月',
      note1: '注意：应收结束时间 "-" 表示未到应收时间或收费已结束',
      note2: '应收金额为-1一般为费用项公式设置出错请检查',
      arrearsSubtotal: '欠费小计：',
      valid: '有效',
      feeEnd: '收费结束',
      payment: '缴费',
      prePayFee: '预付收款',  
      paymentHistory: '缴费历史',
      splitFee: '拆费'
    },
simplifyHisFee: {
      feeItem: '费用项',
      payerObject: '收费对象',
      receiptNumber: '收据编号',
      manualGenerate: '手工生成',
      cycle: '周期(单位:月)',
      receivableReceived: '应收/实收(单位:元)',
      accountDeduction: '账户扣款',
      acctAmount: '账户抵扣',
      discountAmount: '打折金额',
      deductionAmount: '减免金额',
      lateAmount: '滞纳金',
      giftAmount: '赠送金额',
      discountDetail: '打折明细',
      paymentMethod: '缴费方式',
      paymentPeriod: '缴费起始段',
      paymentTime: '缴费时间',
      cashier: '收银员',
      status: '状态',
      remark: '备注',
      operation: '操作',
      detail: '详情',
      generateReceipt: '生成收据',
      systemGenerate: '系统生成',
      custom: '自定义',
      receiptNumberRequired: '必填，请选择收据编号生成方式',
      cancel: '取消',
      generate: '生成',
      viewInFee: '费用中查看'
    },
    simplifyOwnerRooms: {
      batchPay: '批量缴费',
      roomCode: '房屋编号',
      floor: '楼层',
      type: '类型',
      area: '建筑/室内面积',
      rent: '租金',
      validity: '有效期',
      roomStatus: '房屋状态',
      roomOweFee: '房屋欠费',
      updateDaily: '按天更新',
      actions: '操作',
      choose: '选择',
      currentRoom: '当前房屋',
      subtotalOweFee: '欠费小计',
      note1: '注意：应收结束时间 "-" 表示未到应收时间或收费已结束',
      note2: '注意：应收金额为-1 一般为费用项公式设置出错请检查'
    },
    carDetailOwner: {
      ownerFace: '业主人脸',
      name: '姓名',
      gender: '性别',
      male: '男',
      female: '女',
      idCard: '身份证',
      address: '家庭住址',
      roomCount: '房屋数',
      memberCount: '业主成员',
      carCount: '车辆数',
      complaintCount: '投诉',
      repairCount: '报修',
      oweFee: '欠费',
      contractCount: '业主合同',
      actions: '操作',
      detail: '详情'
    },
    writeOweFeeCallable: {
      title: '催缴登记',
      room: '登记房屋',
      roomPlaceholder: '必填，请填写房屋',
      fees: '催缴费用',
      remark: '催缴说明',
      remarkPlaceholder: '请输入备注',
      cancel: '取消',
      submit: '提交',
      success: '登记成功'
    },
    deleteOweFeeCallable: {
      title: '请确认您的操作!',
      confirmDelete: '确定删除欠费催缴',
      cancel: '点错了',
      confirm: '确认删除!',
      success: '删除成功'
    },
    simplifyCallable: {
      register: '登记',
      callable: '催缴',
      callableOrder: '催缴单',
      noRoomSelected: '未选择房屋',
      id: '编号',
      ownerName: '业主名称',
      payerObjName: '付费对象名称',
      feeName: '费用名称',
      amount: '催缴金额',
      timePeriod: '欠费时间段',
      callableWay: '催缴方式',
      staffName: '催缴人',
      status: '状态',
      remark: '说明',
      createTime: '创建时间',
      actions: '操作',
      delete: '删除'
    },
    simplifyFeeReceipt: {
      selectFeeType: '请选择收费类型',
      selectCar: '请选择车辆',
      selectContract: '请选择合同',
      current: '当前',
      car: '车辆',
      room: '房屋',
      all: '全部',
      receiptCode: '收据编号',
      query: '查询',
      print: '打印',
      mergePrint: '合并打印',
      printSmall: '打印小票',
      apply: '申请单',
      feeType: '费用类型',
      owner: '业主',
      feeItem: '费用项目',
      timePeriod: '收费时间段',
      totalAmount: '总金额',
      payTime: '缴费时间',
      receiptId: '收据ID',
      yuan: '元',
      fee: '费',
      noCar: '没有车位',
      noContract: '没有合同',
      selectReceipt: '请选择收据',
      contract: '合同',
      feeMonth: '计费月',
      payWay: '支付方式',
      deductionAmount: '优惠金额',
      lateAmount: '滞纳金',
      acctAmount: '账户抵扣',
      degree: '抄表起止度数'
    },
    simplifyMeterWaterLog: {
      selectMeterType: '请选择表类型',
      addMeterReading: '水电抄表',
      meterType: '表类型',
      objectName: '对象名称',
      previousReading: '上期度数',
      currentReading: '本期度数',
      previousReadingTime: '上期读表时间',
      currentReadingTime: '本期读表时间',
      createTime: '创建时间'
    },
    prestoreAccount: {
      title: '预存',
      accountType: '账户类型',
      selectAccountType: '必填，请选择账户类型',
      ownerPhone: '业主手机',
      ownerPhonePlaceholder: '必填，请填写业主手机号',
      ownerName: '业主名称',
      selectOwner: '必填，请选择业主',
      deductionRoom: '扣款房屋',
      selectRoom: '必填，请选择房屋',
      prestoreAmount: '预存金额',
      prestoreAmountPlaceholder: '必填，请填写预存金额',
      paymentMethod: '支付方式',
      selectPaymentMethod: '必填，请选择支付方式',
      remark: '备注',
      remarkPlaceholder: '可填，请填写备注',
      cancel: '取消',
      save: '保存',
      validateOwner: '业主不能为空',
      validateAmount: '金额不能为空',
      validateAccountType: '请选择账户类型',
      validateRemark: '备注长度不能超过200位',
      saveSuccess: '预存成功',
      saveFailed: '预存失败'
    },

    simplifyRefundDeposit: {
      chargeObject: '收费对象',
      feeItem: '费用项',
      timePeriod: '时间段',
      amount: '金额',
      paymentTime: '缴费时间',
      status: '状态',
      operation: '操作',
      refundDeposit: '退押金',
      detail: '详情'
    },
    deleteFeeRule: {
      confirmTitle: '请确认您的操作',
      confirmMessage: '确定删除账单规则，删除账单规则时，相关费用及缴费记录也会被删除！',
      cancel: '点错了',
      confirmDelete: '确认删除',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败'
    },
    editFeeRule: {
      title: '账单变更',
      maxTime: '账单结束时间',
      maxTimePlaceholder: '必填，请填写账单结束时间',
      curYearMonth: '账单日',
      curYearMonthPlaceholder: '必填，请填写账单日',
      dateError: '账单日应大于{date}',
      maxTimeRequired: '账单结束时间不能为空',
      curYearMonthRequired: '账单日不能为空'
    },
    finishFeeRule: {
      title: '请确认您的操作',
      confirmMessage: '结束费用账单，账单日不在产生新的账单费用！'
    },
    feeDetailFeeRule: {
      ruleId: '规则编号',
      feeItem: '费用项',
      feeFlag: '费用标识',
      createTime: '建账时间',
      validPeriod: '账单有效期',
      formula: '账单公式',
      price: '计费单价',
      additionalFee: '附加/固定费用',
      status: '状态',
      billDay: '账单日',
      billCycle: '账单周期'
    },
    feeDetailRuleBill: {
      billName: '账单名称',
      feeItem: '费用项',
      receivablePeriod: '应收时间段',
      receivableAmount: '应收金额',
      ruleId: '规则编号',
      feeId: '费用编号',
      status: '状态',
      description: '说明',
      price: '单价',
      fixedFee: '固定费'
    },
    deleteFee: {
      title: '请确认您的操作',
      confirmMessage: '确定删除费用'
    },
    editFee: {
      title: '费用变更',
      startTime: '开始时间',
      startTimePlaceholder: '必填，请填写开始时间',
      endTime: '结束时间',
      endTimePlaceholder: '必填，请填写应收结束时间',
      maxEndTime: '应收结束时间',
      maxEndTimePlaceholder: '必填，请填写应收结束时间',
      rateCycle: '递增周期',
      rateCyclePlaceholder: '必填，请填写递增周期,请填写月份',
      rate: '计费递增率',
      ratePlaceholder: '必填，请填写递增率',
      rateStartTime: '递增开始时间',
      rateStartTimePlaceholder: '必填，请填写递增开始时间',
      startTimeError: '建账时间必须小于计费起始时间',
      endTimeError: '计费起始时间必须大于建账时间',
      maxEndTimeError: '计费结束时间必须大于开始时间',
      rateStartTimeError: '递增开始时间必须大于开始时间',
      startTimeRequired: '建账时间不能为空',
      endTimeRequired: '计费起始时间不能为空',
      oweAmount: '欠费金额',
      oweAmountPlaceholder: '必填，请填写欠费金额'
    },
    roomCreateFeeAdd: {
      title: '创建费用',
      location: '房屋',
      locationPlaceholder: '必填，请填写收费范围',
      feeType: '费用类型',
      feeTypePlaceholder: '必填，请选择费用类型',
      feeItem: '收费项目',
      feeItemPlaceholder: '必填，请选择收费项目',
      amount: '收费金额',
      amountPlaceholder: '必填，请填写收费金额',
      startTime: '计费起始时间',
      startTimePlaceholder: '必填，请填写计费起始时间',
      endTime: '计费结束时间',
      endTimePlaceholder: '必填，请填写计费结束时间',
      rateCycle: '递增周期',
      rateCyclePlaceholder: '必填，请填写递增周期,请填写月份',
      rate: '计费递增率',
      ratePlaceholder: '必填，请填写递增率',
      rateStartTime: '递增开始时间',
      rateStartTimePlaceholder: '必填，请填写递增开始时间',
      validate: {
        locationRequired: '收费对象不能为空',
        feeTypeRequired: '费用类型不能为空',
        feeItemRequired: '费用项目不能为空',
        startTimeRequired: '计费起始时间不能为空',
        endTimeRequired: '计费终止时间不能为空',
        startBeforeEnd: '计费起始时间必须小于计费终止时间',
        endAfterStart: '计费终止时间必须大于计费起始时间'
      },
      successMessage: '创建收费成功'
    },
    roomCreateFeeAddDemo: {
      openModal: '打开创建费用弹窗',
      successMessage: '费用创建成功'
    },
    addProxyFee: {
      title: '按量缴费',
      feeType: '费用类型',
      feeTypePlaceholder: '必填，请选择费用类型',
      feeItem: '收费项目',
      feeItemPlaceholder: '必填，请选择收费项目',
      feeItemTip: '说明：显示公式为(用量*单价+附加费)的费用项',
      chargeObject: '收费对象',
      chargeObjectPlaceholder: '必填，请填写房屋',
      consumption: '用量',
      consumptionPlaceholder: '必填，请填写用量',
      quantity: '个数',
      amount: '金额',
      amountPlaceholder: '必填，请填写金额',
      startTime: '开始时间',
      startTimePlaceholder: '必填，请填写开始时间',
      endTime: '结束时间',
      endTimePlaceholder: '必填，请填写结束时间',
      waterFee: '水费',
      electricityFee: '电费',
      otherFee: '其他',
      validate: {
        amountRequired: '金额不能为空',
        amountFormat: '金额格式错误，如3.00',
        consumptionRequired: '用量不能为空',
        consumptionFormat: '用量格式错误，如3.00',
        roomRequired: '房屋必填',
        feeRequired: '费用必填',
        startTimeRequired: '开始时间不能为空',
        endTimeRequired: '结束时间不能为空',
        startBeforeEnd: '开始时间必须小于结束时间',
        endAfterStart: '结束时间必须大于开始时间',
        invalidConfig: '未选择收费项目或者收费项目公式错误',
        amountTooSmall: '输入金额太小'
      },
      successMessage: '保存成功'
    },
    addProxyFeeDemo: {
      openModal: '打开按量缴费弹窗',
      successMessage: '保存成功'
    },
    exportFeeImportExcel: {
      title: '模板导出',
      floor: '楼栋',
      feeItem: '费用项',
      all: '全部',
      successMessage: '导出成功'
    },
    exportFeeImportExcelDemo: {
      openModal: '打开模板导出弹窗'
    },
    doImportCreateFee: {
      title: '自定义创建费用',
      selectFile: '选择文件',
      clickUpload: '点击上传',
      fileTip: '必填，请选择数据文件',
      validate: {
        invalidFileType: '不是有效的Excel格式',
        fileTooLarge: 'Excel文件大小不能超过2M'
      },
      successMessage: '导入成功'
    },
    doImportCreateFeeDemo: {
      openModal: '打开自定义创建费用弹窗'
    },
    downloadCollectionLetterOrder: {
      title: '批量催缴单',
      confirmExport: '确认导出催缴单',
      selectFloor: '选择楼栋',
      floorPlaceholder: '必填，请选择楼栋'
    },
    downloadCollectionLetterOrderDemo: {
      openModal: '打开催缴单弹窗'
    },
    prePayFeeDetail: {
      feeName: '费用名称',
      payerObjName: '付费对象',
      ownerName: '业主名称',
      cycles: '周期',
      receivableReceivedAmount: '应收/实收金额',
      remainAmount: '剩余金额',
      primeRateName: '支付方式',
      prePayPeriod: '预付期',
      stateName: '状态',
      cashierName: '收银员',
      discountAmount: '优惠金额',
      createTime: '预付时间',
      deductionWay: '扣款',
      remark: '备注',
      operation: '操作',
      refund: '退款',
      manualDeduction: '手动扣款',
      autoDeduction: '自动扣款',
      deductionDetail: '扣款明细',
      totalRemainAmount: '剩余合计',
      auto: '自动',
      manual: '手动',
      fetchError: '获取预付费用详情失败',
      operationSuccess: '操作成功',
      operationError: '操作失败'
    },
    splitFee: {
      title: '拆分费用',
      feeName: '费用项目:',
      timePeriod: '时间段:',
      oweAmount: '应收金额:',
      remark: '说明',
      operation: '操作',
      oweAmountPlaceholder: '必填，请填写应收金额',
      remarkPlaceholder: '选填，请填写说明',
      add: '增加',
      delete: '删除',
      amountSumError: '分摊金额之和不等于应收金额!',
      operationSuccess: '操作成功'
}
  },
  'zh-TW': {
    roomCreateFee: {
      customTemplate: '自定義範本',
      customImport: '自定義匯入',
      batchCreate: '批量創建',
      batchCollectionLetter: '批量催繳單',
      roomNumPlaceholder: '房屋編號,如1-1-1123',
      ownerNamePlaceholder: '請填寫業主名稱',
      roomFee: '房屋費用',
      paymentHistory: '繳費歷史',
      rooms: '房屋',
      owner: '業主',
      callable: '催繳',
      receiptReprint: '補打收據',
      meterReadingRecords: '抄表記錄',
      prepaidAccount: '預存帳戶',
      prepaidReprint: '預存補打',
      deposit: '押金',
      billingRules: '設定費用',
      feeBills: '費用帳單',
      prePayFee: '預付收款',
      onlyHasOwnerTip: '僅顯示有業主的房屋'
    },
    inputSearchRoom: {
      noRoomFound: '未查詢到房屋'
    },
    inputSearchRoomDemo: {
      searchPlaceholder: '按房號搜尋'
    },
    inputSearchRoomByOwnerDemo: {
      searchPlaceholder: '按業主姓名搜尋'
    },
    tempImportRoomFee: {
      title: '臨時收費',
      feeType: '費用類型',
      selectFeeType: '必填，請選擇費用類型',
      feeObj: '費用對象',
      inputFeeObj: '必填，請填寫費用對象',
      feeName: '費用名稱',
      selectFeeItem: '必填，選擇收費項目',
      feeItemDesc: '說明：顯示公式為動態費用的費用項',
      inputFeeName: '必填，請填寫費用名稱',
      select: '選擇',
      amount: '收費金額',
      inputAmount: '必填，請填寫收費金額',
      startTime: '開始時間',
      selectStartTime: '必填，請填寫開始時間',
      endTime: '結束時間',
      selectEndTime: '必填，請填寫結束時間',
      cancel: '取消',
      submit: '提交',
      feeTypeRequired: '費用類型不能為空',
      feeNameRequired: '費用名稱不能為空',
      feeObjRequired: '費用對象不能為空',
      startTimeRequired: '開始時間不能為空',
      endTimeRequired: '結束時間不能為空',
      endTimeMustAfterStart: '結束時間必須大於開始時間',
      amountRequired: '金額不能為空',
      createdSuccess: '創建成功',
      createFailed: '創建失敗'
    },
    tempImportRoomFeeDemo: {
      openModal: '打開臨時收費視窗'
    },
    simplifyRoomFee: {
      selectFeeType: '請選擇費用類型',
      selectFeeItem: '請選擇收費項目',
      selectStatus: '請選擇狀態',
      currentRoom: '目前房屋',
      currentOwner: '目前業主',
      default: '預設',
      monthly: '按月',
      batchPayment: '批量繳費',
      tempFee: '臨時收費',
      quantityPayment: '按量繳費',
      waterElectricity: '水電抄表',
      feePackage: '費用套餐',
      createFee: '創建費用',
      arrearsPayment: '欠費繳費',
      feeItem: '費用項目',
      feeFlag: '費用標識',
      feeType: '費用類型',
      receivableAmount: '應收金額',
      accountTime: '建帳時間',
      receivablePeriod: '應收時間段',
      description: '說明',
      remark: '備註',
      status: '狀態',
      operation: '操作',
      preDegrees: '上期度數：',
      curDegrees: '本期度數：',
      unitPrice: '單價：',
      additionalFee: '附加費：',
      usage: '用量：',
      algorithm: '演算法：',
      fixedFee: '固定費：',
      moreOperations: '更多操作',
      cancelFee: '取消費用',
      manualEnd: '手工結束',
      feeChange: '費用變更',
      details: '詳情',
      chargeYearMonth: '收費年月',
      note1: '注意：應收結束時間「-」表示未到應收時間或收費已結束',
      note2: '應收金額為-1一般為費用項目公式設定出錯請檢查',
      arrearsSubtotal: '欠費小計：',
      valid: '有效',
      feeEnd: '收費結束',
      payment: '繳費',
      prePayFee: '預付收款',
      paymentHistory: '繳費歷史',
      splitFee: '拆費'
    },
simplifyHisFee: {
      feeItem: '費用項目',
      payerObject: '收費對象',
      receiptNumber: '收據編號',
      manualGenerate: '手工生成',
      cycle: '週期(單位:月)',
      receivableReceived: '應收/實收(單位:元)',
      accountDeduction: '帳戶扣款',
      acctAmount: '帳戶抵扣',
      discountAmount: '打折金額',
      deductionAmount: '減免金額',
      lateAmount: '滯納金',
      giftAmount: '贈送金額',
      discountDetail: '打折明細',
      paymentMethod: '繳費方式',
      paymentPeriod: '繳費起始段',
      paymentTime: '繳費時間',
      cashier: '收銀員',
      status: '狀態',
      remark: '備註',
      operation: '操作',
      detail: '詳情',
      generateReceipt: '生成收據',
      systemGenerate: '系統生成',
      custom: '自定義',
      receiptNumberRequired: '必填，請選擇收據編號生成方式',
      cancel: '取消',
      generate: '生成',
      viewInFee: '費用中查看'
    },
    simplifyOwnerRooms: {
      batchPay: '批量繳費',
      roomCode: '房屋編號',
      floor: '樓層',
      type: '類型',
      area: '建築/室內面積',
      rent: '租金',
      validity: '有效期',
      roomStatus: '房屋狀態',
      roomOweFee: '房屋欠費',
      updateDaily: '按天更新',
      actions: '操作',
      choose: '選擇',
      currentRoom: '目前房屋',
      subtotalOweFee: '欠費小計',
      note1: '注意：應收結束時間 "-" 表示未到應收時間或收費已結束',
      note2: '注意：應收金額為-1 一般為費用項公式設定出錯請檢查'
    },
    carDetailOwner: {
      ownerFace: '業主人臉',
      name: '姓名',
      gender: '性別',
      male: '男',
      female: '女',
      idCard: '身份證',
      address: '家庭住址',
      roomCount: '房屋數',
      memberCount: '業主成員',
      carCount: '車輛數',
      complaintCount: '投訴',
      repairCount: '報修',
      oweFee: '欠費',
      contractCount: '業主合約',
      actions: '操作',
      detail: '詳情'
    },
    writeOweFeeCallable: {
      title: '催繳登記',
      room: '登記房屋',
      roomPlaceholder: '必填，請填寫房屋',
      fees: '催繳費用',
      remark: '催繳說明',
      remarkPlaceholder: '請輸入備註',
      cancel: '取消',
      submit: '提交',
      success: '登記成功'
    },
    deleteOweFeeCallable: {
      title: '請確認您的操作!',
      confirmDelete: '確定刪除欠費催繳',
      cancel: '點錯了',
      confirm: '確認刪除!',
      success: '刪除成功'
    },
    simplifyCallable: {
      register: '登記',
      callable: '催繳',
      callableOrder: '催繳單',
      noRoomSelected: '未選擇房屋',
      id: '編號',
      ownerName: '業主名稱',
      payerObjName: '付費對象名稱',
      feeName: '費用名稱',
      amount: '催繳金額',
      timePeriod: '欠費時間段',
      callableWay: '催繳方式',
      staffName: '催繳人',
      status: '狀態',
      remark: '說明',
      createTime: '創建時間',
      actions: '操作',
      delete: '刪除'
    },
    simplifyFeeReceipt: {
      selectFeeType: '請選擇收費類型',
      selectCar: '請選擇車輛',
      selectContract: '請選擇合約',
      current: '目前',
      car: '車輛',
      room: '房屋',
      all: '全部',
      receiptCode: '收據編號',
      query: '查詢',
      print: '列印',
      mergePrint: '合併列印',
      printSmall: '列印小票',
      apply: '申請單',
      feeType: '費用類型',
      owner: '業主',
      feeItem: '費用項目',
      timePeriod: '收費時間段',
      totalAmount: '總金額',
      payTime: '繳費時間',
      receiptId: '收據ID',
      yuan: '元',
      fee: '費',
      noCar: '沒有車位',
      noContract: '沒有合約',
      selectReceipt: '請選擇收據',
      contract: '合約',
      feeMonth: '計費月',
      payWay: '支付方式',
      deductionAmount: '優惠金額',
      lateAmount: '滯納金',
      acctAmount: '帳戶抵扣',
      degree: '抄表起止度數'
    },
    simplifyMeterWaterLog: {
      selectMeterType: '請選擇表類型',
      addMeterReading: '水電抄表',
      meterType: '表類型',
      objectName: '對象名稱',
      previousReading: '上期度數',
      currentReading: '本期度數',
      previousReadingTime: '上期讀表時間',
      currentReadingTime: '本期讀表時間',
      createTime: '創建時間'
    },
    prestoreAccount: {
      title: '預存',
      accountType: '帳戶類型',
      selectAccountType: '必填，請選擇帳戶類型',
      ownerPhone: '業主手機',
      ownerPhonePlaceholder: '必填，請填寫業主手機號',
      ownerName: '業主名稱',
      selectOwner: '必填，選擇業主',
      deductionRoom: '扣款房屋',
      selectRoom: '必填，請選擇房屋',
      prestoreAmount: '預存金額',
      prestoreAmountPlaceholder: '必填，請填寫預存金額',
      paymentMethod: '支付方式',
      selectPaymentMethod: '必填，請選擇支付方式',
      remark: '備註',
      remarkPlaceholder: '可填，請填寫備註',
      cancel: '取消',
      save: '儲存',
      validateOwner: '業主不能為空',
      validateAmount: '金額不能為空',
      validateAccountType: '請選擇帳戶類型',
      validateRemark: '備註長度不能超過200位',
      saveSuccess: '預存成功',
      saveFailed: '預存失敗'
    },
    simplifyRefundDeposit: {
      chargeObject: '收費對象',
      feeItem: '費用項',
      timePeriod: '時間段',
      amount: '金額',
      paymentTime: '繳費時間',
      status: '狀態',
      operation: '操作',
      refundDeposit: '退押金',
      detail: '詳情'
    },
    deleteFeeRule: {
      confirmTitle: '請確認您的操作',
      confirmMessage: '確定刪除帳單規則，刪除帳單規則時，相關費用及繳費記錄也會被刪除！',
      cancel: '點錯了',
      confirmDelete: '確認刪除',
      deleteSuccess: '刪除成功',
      deleteFailed: '刪除失敗'
    },
    editFeeRule: {
      title: '帳單變更',
      maxTime: '帳單結束時間',
      maxTimePlaceholder: '必填，請填寫帳單結束時間',
      curYearMonth: '帳單日',
      curYearMonthPlaceholder: '必填，請填寫帳單日',
      dateError: '帳單日應大於{date}',
      maxTimeRequired: '帳單結束時間不能為空',
      curYearMonthRequired: '帳單日不能為空'
    },
    finishFeeRule: {
      title: '請確認您的操作',
      confirmMessage: '結束費用帳單，帳單日不再產生新的帳單費用！'
    },
    feeDetailFeeRule: {
      ruleId: '規則編號',
      feeItem: '費用項',
      feeFlag: '費用標識',
      createTime: '建帳時間',
      validPeriod: '帳單有效期',
      formula: '帳單公式',
      price: '計費單價',
      additionalFee: '附加/固定費用',
      status: '狀態',
      billDay: '帳單日',
      billCycle: '帳單週期'
    },
    feeDetailRuleBill: {
      billName: '帳單名稱',
      feeItem: '費用項',
      receivablePeriod: '應收時間段',
      receivableAmount: '應收金額',
      ruleId: '規則編號',
      feeId: '費用編號',
      status: '狀態',
      description: '說明',
      price: '單價',
      fixedFee: '固定費'
    },
    deleteFee: {
      title: '請確認您的操作',
      confirmMessage: '確定刪除費用'
    },
    editFee: {
      title: '費用變更',
      startTime: '開始時間',
      startTimePlaceholder: '必填，請填寫開始時間',
      endTime: '結束時間',
      endTimePlaceholder: '必填，請填寫應收結束時間',
      maxEndTime: '應收結束時間',
      maxEndTimePlaceholder: '必填，請填寫應收結束時間',
      rateCycle: '遞增週期',
      rateCyclePlaceholder: '必填，請填寫遞增週期,請填寫月份',
      rate: '計費遞增率',
      ratePlaceholder: '必填，請填寫遞增率',
      rateStartTime: '遞增開始時間',
      rateStartTimePlaceholder: '必填，請填寫遞增開始時間',
      startTimeError: '建帳時間必須小於計費起始時間',
      endTimeError: '計費起始時間必須大於建帳時間',
      maxEndTimeError: '計費結束時間必須大於開始時間',
      rateStartTimeError: '遞增開始時間必須大於開始時間',
      startTimeRequired: '建帳時間不能為空',
      endTimeRequired: '計費起始時間不能為空',
      oweAmount: '欠費金額',
      oweAmountPlaceholder: '必填，請填寫欠費金額'
    },
    roomCreateFeeAdd: {
      title: '創建費用',
      location: '房屋',
      locationPlaceholder: '必填，請填寫收費範圍',
      feeType: '費用類型',
      feeTypePlaceholder: '必填，請選擇費用類型',
      feeItem: '收費項目',
      feeItemPlaceholder: '必填，選擇收費項目',
      amount: '收費金額',
      amountPlaceholder: '必填，請填寫收費金額',
      startTime: '計費起始時間',
      startTimePlaceholder: '必填，請填寫計費起始時間',
      endTime: '計費結束時間',
      endTimePlaceholder: '必填，請填寫計費結束時間',
      rateCycle: '遞增週期',
      rateCyclePlaceholder: '必填，請填寫遞增週期,請填寫月份',
      rate: '計費遞增率',
      ratePlaceholder: '必填，請填寫遞增率',
      rateStartTime: '遞增開始時間',
      rateStartTimePlaceholder: '必填，請填寫遞增開始時間',
      validate: {
        locationRequired: '收費對象不能為空',
        feeTypeRequired: '費用類型不能為空',
        feeItemRequired: '費用項目不能為空',
        startTimeRequired: '計費起始時間不能為空',
        endTimeRequired: '計費終止時間不能為空',
        startBeforeEnd: '計費起始時間必須小於計費終止時間',
        endAfterStart: '計費終止時間必須大於計費起始時間'
      },
      successMessage: '創建收費成功'
    },
    roomCreateFeeAddDemo: {
      openModal: '打開創建費用視窗',
      successMessage: '費用創建成功'
    },
    addProxyFee: {
      title: '按量繳費',
      feeType: '費用類型',
      feeTypePlaceholder: '必填，請選擇費用類型',
      feeItem: '收費項目',
      feeItemPlaceholder: '必填，選擇收費項目',
      feeItemTip: '說明：顯示公式為(用量*單價+附加費)的費用項',
      chargeObject: '收費對象',
      chargeObjectPlaceholder: '必填，請填寫房屋',
      consumption: '用量',
      consumptionPlaceholder: '必填，請填寫用量',
      quantity: '個數',
      amount: '金額',
      amountPlaceholder: '必填，請填寫金額',
      startTime: '開始時間',
      startTimePlaceholder: '必填，請填寫開始時間',
      endTime: '結束時間',
      endTimePlaceholder: '必填，請填寫結束時間',
      waterFee: '水費',
      electricityFee: '電費',
      otherFee: '其他',
      validate: {
        amountRequired: '金額不能為空',
        amountFormat: '金額格式錯誤，如3.00',
        consumptionRequired: '用量不能為空',
        consumptionFormat: '用量格式錯誤，如3.00',
        roomRequired: '房屋必填',
        feeRequired: '費用必填',
        startTimeRequired: '開始時間不能為空',
        endTimeRequired: '結束時間不能為空',
        startBeforeEnd: '開始時間必須小於結束時間',
        endAfterStart: '結束時間必須大於開始時間',
        invalidConfig: '未選擇收費項目或收費項目公式錯誤',
        amountTooSmall: '輸入金額太小'
      },
      successMessage: '儲存成功'
    },
    addProxyFeeDemo: {
      openModal: '打開按量繳費視窗',
      successMessage: '儲存成功'
    },
    exportFeeImportExcel: {
      title: '範本匯出',
      floor: '樓棟',
      feeItem: '費用項',
      all: '全部',
      successMessage: '匯出成功'
    },
    exportFeeImportExcelDemo: {
      openModal: '打開範本匯出視窗'
    },
    doImportCreateFee: {
      title: '自定義創建費用',
      selectFile: '選擇檔案',
      clickUpload: '點擊上傳',
      fileTip: '必填，請選擇資料檔案',
      validate: {
        invalidFileType: '不是有效的Excel格式',
        fileTooLarge: 'Excel檔案大小不能超過2M'
      },
      successMessage: '匯入成功'
    },
    doImportCreateFeeDemo: {
      openModal: '打開自定義創建費用視窗'
    },
    downloadCollectionLetterOrder: {
      title: '批量催繳單',
      confirmExport: '確認匯出催繳單',
      selectFloor: '選擇樓棟',
      floorPlaceholder: '必填，請選擇樓棟'
    },
    downloadCollectionLetterOrderDemo: {
      openModal: '打開催繳單視窗'
    },
    prePayFeeDetail: {
      feeName: '費用名稱',
      payerObjName: '付費對象',
      ownerName: '業主名稱',
      cycles: '週期',
      receivableReceivedAmount: '應收/實收金額',
      remainAmount: '剩餘金額',
      primeRateName: '支付方式',
      prePayPeriod: '預付期',
      stateName: '狀態',
      cashierName: '收銀員',
      discountAmount: '優惠金額',
      createTime: '預付時間',
      deductionWay: '扣款',
      remark: '備註',
      operation: '操作',
      refund: '退款',
      manualDeduction: '手動扣款',
      autoDeduction: '自動扣款',
      deductionDetail: '扣款明細',
      totalRemainAmount: '剩餘合計',
      auto: '自動',
      manual: '手動',
      fetchError: '獲取預付費用詳情失敗',
      operationSuccess: '操作成功',
      operationError: '操作失敗'
    },
    splitFee: {
      title: '拆分費用',
      feeName: '費用項目:',
      timePeriod: '時間段:',
      oweAmount: '應收金額:',
      remark: '說明',
      operation: '操作',
      oweAmountPlaceholder: '必填，請填寫應收金額',
      remarkPlaceholder: '選填，請填寫說明',
      add: '增加',
      delete: '刪除',
      amountSumError: '分攤金額之和不等於應收金額!',
      operationSuccess: '操作成功'
    }
  }
}